module.exports = __webpack_public_path__ + "media/bom/arrow-ba29eee2.png";